@if (!fromGrid && product$ | async; as product) { @if (product.potentialPromotions?.length > 0) {
<div class="product-promotions">
  @for (promo of product.potentialPromotions; track promo) { @if (promo?.description && promo?.description !== '') {
  <div class="product-promo-wrapper">
    <div class="product-promo">
      @if (tooltipIconConfig$ | async; as tooltipIconConfig) {
      <div class="promo-block">
        <app-tooltip-text
          class="promo-truncate"
          [tooltipContent]="concatText(promo.description, 'product.promo' | cxTranslate)"
          [content]="promo.description"
          [promotionLocation]="'PDP'"
          placement="right"
          [charactersLimit]="34"
        >
        </app-tooltip-text>
        @if (tooltipIconConfig?.enabled) {
        <app-tooltip-icon
          [matIconName]="tooltipIconConfig?.matIconName"
          [matIconTheme]="tooltipIconConfig?.matIconTheme"
          placement="bottom-right"
          [size]="tooltipIconConfig?.size"
          [tooltipContent]="'tooltip.promotion' | cxTranslate"
          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
        ></app-tooltip-icon>
        }
      </div>
      }
    </div>
  </div>
  }
  <br />
  }
</div>
} } @else { @if (fromGrid && promProductsFromGrid$ | async; as productss) { @if (productss.potentialPromotions?.length >
0) {
<div class="product-promotions">
  @for (promo of productss.potentialPromotions; track promo) { @if (promo?.description && promo?.description !== '') {
  <div class="product-promo-wrapper">
    <div class="product-promo">
      @if (tooltipIconConfig$ | async; as tooltipIconConfig) {
      <div class="promo-block">
        <app-tooltip-text
          class="promo-truncate"
          [tooltipContent]="concatText(promo.description, 'product.promo' | cxTranslate)"
          [content]="promo.description"
          [promotionLocation]="'PDP'"
          placement="right"
          [charactersLimit]="34"
        >
        </app-tooltip-text>
        @if (tooltipIconConfig?.enabled) {
        <app-tooltip-icon
          [matIconName]="tooltipIconConfig?.matIconName"
          [matIconTheme]="tooltipIconConfig?.matIconTheme"
          placement="bottom-right"
          [size]="tooltipIconConfig?.size"
          [tooltipContent]="'tooltip.promotion' | cxTranslate"
          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
        ></app-tooltip-icon>
        }
      </div>
      }
    </div>
    <br />
  </div>
  } }
</div>
} } }
